
import { defineComponent } from 'vue';
import { AppInput, AppButton } from '@/components';
import { useForgotPassword } from '@/modules/forgot-password/forgot-password';
import { ROUTE_NAME_LOGIN } from '@/modules/login/router';
import { ROUTE_NAME_PASSWORD } from '@/modules/forgot-password/router';

export default defineComponent({
    name: ROUTE_NAME_PASSWORD.FORGOT,
    components: { AppInput, AppButton },
    setup() {
        const { model, v$, actions } = useForgotPassword();

        return { v$, model, actions, ROUTE_NAME_LOGIN };
    }
});
